import { Modal, Select, App } from 'antd';
import React, { useEffect, useState } from 'react';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import { getFlows, triggerFlowForCustomer, triggerFlowForCompany } from 'api/flows';

function RunFlowModal({ open, onClose, onSuccess, customerId, companyId }) {
  const [flows, setFlows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFlowId, setSelectedFlowId] = useState(null);
  const [running, setRunning] = useState(false);
  const { message } = App.useApp();

  useEffect(() => {
    if (open) {
      setLoading(true);
      setSelectedFlowId(null);
      getFlows({ status: 'active' })
        .then((res) => {
          const data = getData(res)?.data ?? getData(res);
          const results = data?.results ?? (Array.isArray(data) ? data : []);
          setFlows(Array.isArray(results) ? results : []);
          setLoading(false);
        })
        .catch((e) => {
          captureException(e);
          message.error('Failed to load flows');
          setLoading(false);
        });
    }
  }, [open, message]);

  const handleRun = () => {
    if (!selectedFlowId) {
      message.warning('Please select a flow');
      return;
    }
    setRunning(true);
    const trigger = customerId
      ? () => triggerFlowForCustomer(customerId, selectedFlowId)
      : () => triggerFlowForCompany(companyId, selectedFlowId);

    trigger()
      .then((res) => {
        const data = getData(res)?.data ?? getData(res);
        const status = data?.status ?? 'completed';
        message.success(`Flow ${status === 'completed' ? 'completed' : 'started'} successfully`);
        onSuccess?.();
        onClose();
      })
      .catch((e) => {
        captureException(e);
        const errMsg = e?.response?.data?.errors?.execution
          ?? e?.response?.data?.errors?.flow
          ?? 'Failed to run flow';
        message.error(typeof errMsg === 'string' ? errMsg : 'Failed to run flow');
      })
      .finally(() => setRunning(false));
  };

  return (
    <Modal
      title="Run Flow"
      open={open}
      onCancel={onClose}
      onOk={handleRun}
      okText="Run"
      confirmLoading={running}
      destroyOnClose
    >
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>Select flow</label>
        <Select
          placeholder="Choose an active flow"
          style={{ width: '100%' }}
          loading={loading}
          value={selectedFlowId}
          onChange={setSelectedFlowId}
          options={flows.map((f) => ({ label: f.name, value: f.id }))}
          allowClear
        />
      </div>
    </Modal>
  );
}

export default RunFlowModal;
